import CanvasRenderer, { RenderingStatus } from "./canvas-renderer";
const DEFAULT_CROP = [0, 0, 0, 0];
export default class AnimationRenderer extends CanvasRenderer {
    performRendering(data, timestamp) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const { animation } = data;
        if ((_b = (_a = data.animation) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.image) {
            const frame = (_c = animation === null || animation === void 0 ? void 0 : animation.getFrame(timestamp, data.startTime)) !== null && _c !== void 0 ? _c : 0;
            const [x, y, width, height] = (_d = animation === null || animation === void 0 ? void 0 : animation.getCrop(frame)) !== null && _d !== void 0 ? _d : DEFAULT_CROP;
            if (this.context) {
                this.context.drawImage((_f = (_e = data.animation) === null || _e === void 0 ? void 0 : _e.asset) === null || _f === void 0 ? void 0 : _f.image, x, y, width, height, 0, 0, (_h = (_g = this.canvas) === null || _g === void 0 ? void 0 : _g.width) !== null && _h !== void 0 ? _h : 0, (_k = (_j = this.canvas) === null || _j === void 0 ? void 0 : _j.height) !== null && _k !== void 0 ? _k : 0);
            }
            if (frame >= data.animation.getTotalFrames()) {
                return RenderingStatus.COMPLETED;
            }
        }
        return RenderingStatus.RENDERING;
    }
}
